import {Routes, Route} from 'react-router-dom';
import {IndexPage} from './pages/IndexPage';

export const ProviderMappingsLayout = () => {
    return (
        <Routes>
            <Route index element={<IndexPage />} />
        </Routes>
    );
};
